<script lang="ts">
	//Formating
	import { format } from 'svelte-i18n';
	//Design system components
	import { Toggle, TemperatureWheel } from '@Shelly/shelly-design-system';
	//Helpers
	import { getComponentByDeviceMode } from 'src/helpers/actions/local/core/local_action_components_helpers';
	//Types
	import type { LocalControlOptions } from 'src/types/requests/schedules/schedules_g2';
	import type { Device } from 'src/types/Device';

	export let controlOption: LocalControlOptions, device: Device;

	const valueRange = getComponentByDeviceMode(device).colorTemp;

	if (controlOption.params.ct == null) {
		controlOption.params.ct =
			valueRange?.maxValue && valueRange?.minValue
				? (valueRange.maxValue - valueRange.minValue) / 2 + valueRange.minValue
				: 4750;
	}

	const a11yProps = {
		tempWheelAriaLabel: $format('label_color_temperature', {
			default: 'Color temperature',
		}),
		thumbAriaLabel: $format('label_color_temperature_thumb', {
			default: 'Color temperature thumb',
		}),
		incrementBtnAriaLabel: $format('button_increase_color_temperature', {
			default: 'Increase color temperature',
		}),
		decrementBtnAriaLabel: $format('button_decrease_color_temperature', {
			default: 'Decrease color temperature',
		}),
	};
</script>

<div>
	<Toggle class="mb-m" size="m" bind:checked={controlOption.attr.ct} id="toggle-v2erxl6">
		{$format('label_set_cct_property', {
			default: 'Set color temperature',
		})}
	</Toggle>

	<TemperatureWheel
		{a11yProps}
		class="mb-s"
		value={controlOption.params.ct}
		min={valueRange?.minValue}
		max={valueRange?.maxValue}
		disabled={!controlOption.attr.ct}
		on:value_change={(event) => {
			controlOption.params.ct = event.detail.value;
		}}
	/>
</div>
